import React from 'react';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-cyan-500/20 shadow-lg shadow-cyan-500/10 overflow-visible" role="banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-4 sm:pt-5 pb-3 sm:pb-4 flex justify-center items-center overflow-visible">
        <div className="group cursor-pointer transition-transform hover:scale-105 duration-300 overflow-visible" role="img" aria-label="DM.AI 4u Logo">
          <img
            src="/dm4u-logo-transparent.png"
            alt="DM.AI 4u - Digital Marketing and AI Solutions"
            className="h-20 sm:h-24 md:h-32 lg:h-36 w-auto max-w-[calc(100vw-2rem)] object-contain drop-shadow-2xl drop-shadow-cyan-500/50 group-hover:drop-shadow-cyan-400/70 transition-all duration-300"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
